function ESignatureLoadingIndicator() {
  return (
    <div className="w-[209px] h-[123px] mb-3 p-4 bg-dropDownBorder animate-pulse " />
  );
}

export default ESignatureLoadingIndicator;